import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { Placeholder, isPlaceholder } from "./Placeholder";

export const FaqAccordion = ({ faqs, testIdPrefix = "faq" }) => (
  <Accordion type="single" collapsible className="w-full space-y-3">
    {faqs.map((item, i) => (
      <AccordionItem
        key={i}
        value={`item-${i}`}
        data-testid={`${testIdPrefix}-item-${i}`}
        className="rounded-2xl border border-brand-line bg-white px-5 shadow-sm transition-shadow hover:shadow-md"
      >
        <AccordionTrigger
          data-testid={`${testIdPrefix}-trigger-${i}`}
          className="py-5 text-left font-display text-base font-bold text-brand-ink hover:text-brand hover:no-underline sm:text-lg"
        >
          {item.q}
        </AccordionTrigger>
        <AccordionContent className="pb-5 text-base leading-relaxed text-brand-muted">
          {isPlaceholder(item.a) ? (
            <span className="flex flex-col items-start gap-2">
              <Placeholder>{item.a}</Placeholder>
              {item.note && <span>{item.note}</span>}
            </span>
          ) : (
            <>
              {item.a}
              {item.note && <span className="mt-2 block">{item.note}</span>}
            </>
          )}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
